<template>
    <div>
        <el-tabs class="welcome_tab" type="border-card">
            <div class="welcome-prompt">Welcome to Add Device.</div>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: 'AddDevice',
        components: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/area/AddDevice.vue